module.exports = __webpack_public_path__ + "static/media/facebook-brands-solid-full.373340ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook-brands-solid-full.svg
// module id = 228
// module chunks = 0